"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
require("reflect-metadata");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const apigw_models_1 = require("@integration/apigw-models");
class SupplyAddressQueryParams extends apigw_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.Matches)(/^\d+$/),
    (0, class_validator_1.MinLength)(10),
    (0, class_validator_1.MaxLength)(10),
    (0, apigw_models_1.Docs)({
        example: '0171441447',
        description: 'The business partner id of the account',
    }),
    (0, class_transformer_1.Expose)({ name: 'account_id' }),
    tslib_1.__metadata("design:type", String)
], SupplyAddressQueryParams.prototype, "accountId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.Matches)(/^\d+$/),
    (0, class_validator_1.MinLength)(9),
    (0, class_validator_1.MaxLength)(10),
    (0, class_transformer_1.Expose)({ name: 'supply_address_id' })
    // FIXME: current example is real world user, because dummy users do not have supply_address_id codes
    ,
    (0, apigw_models_1.Docs)({ example: '0703388787', description: 'The supply address identifier key' }),
    tslib_1.__metadata("design:type", String)
], SupplyAddressQueryParams.prototype, "supplyAddressId", void 0);
exports.default = SupplyAddressQueryParams;
